import ProductListPopupCellRenderer from './ProductListMenu/ProductListMenu';
import {
  dateFormat,
  preorderDateFormat,
} from '../../common/Grid/GridUtilities';
import ChecklistFilter from '../../common/Grid/ChecklistFilter/ChecklistFilter';
import FormatTypeRenderer from './FormatTypeRenderer';
import AlbumStateRenderer from './AlbumStateRenderer';
import TitleVersionRenderer from './TitleVersionRenderer';
import { TranslatableColDef } from '../../common/Grid/TranslatableColDef';
import {
  translateMerchandiseProductType,
  translatePhysicalProductType,
} from '@/helpers/translateProductType';

const overflowCellStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const merchandiseProductListColDef: TranslatableColDef[] = [
  {
    field: 'id',
    headerName: 'id',
    hide: true,
    cellStyle: overflowCellStyle,
    suppressColumnsToolPanel: true,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated At',
    hide: true,
    sort: 'desc',
    cellStyle: overflowCellStyle,
    suppressColumnsToolPanel: true,
  },
  {
    field: 'format',
    tooltipValueGetter: (props) =>
      translatePhysicalProductType(props.data.format.name),
    headerName: 'Format',
    headerNameTranslationKey: 'product.editProduct.type',
    sortable: true,
    resizable: true,
    filter: ChecklistFilter,
    suppressHeaderMenuButton: false,
    cellRenderer: FormatTypeRenderer,
    cellClass: 'grid-badge',
    flex: 2,
    maxWidth: 180,
  },
  {
    field: 'merchandiseMetadata.merchandiseType',
    tooltipValueGetter: (props) =>
      translateMerchandiseProductType(props.data.merchandiseType?.name),
    headerName: 'SubType',
    headerNameTranslationKey: 'product.editProduct.subType',
    sortable: true,
    resizable: true,
    filter: ChecklistFilter,
    suppressHeaderMenuButton: false,
    cellRenderer: (props: any) =>
      translateMerchandiseProductType(props.data.merchandiseType?.name),
    cellStyle: overflowCellStyle,
    flex: 2,
    maxWidth: 180,
  },
  {
    field: 'title',
    tooltipField: 'title',
    headerName: 'Title',
    headerNameTranslationKey: 'product.editProduct.displayName',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellRenderer: TitleVersionRenderer,
    cellStyle: overflowCellStyle,
    flex: 3,
  },
  {
    field: 'displayArtist',
    tooltipField: 'displayArtist',
    headerName: 'Display Artist',
    headerNameTranslationKey: 'product.editProduct.artistBrand',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 3,
  },
  {
    field: 'labelName',
    tooltipField: 'labelName',
    headerName: 'Label',
    headerNameTranslationKey: 'product.editProduct.labelname',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'releaseDate',
    tooltipField: 'releaseDate',
    headerName: 'Release Date',
    headerNameTranslationKey: 'product.editProduct.releaseDate',
    sortable: true,
    resizable: true,
    filter: 'agDateColumnFilter',
    valueFormatter: dateFormat,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'gtin',
    tooltipField: 'gtin',
    headerName: 'UPC',
    headerNameTranslationKey: 'product.editProduct.GTIN',
    sortable: true,
    resizable: true,
    filter: 'agTextColumnFilter',
    cellStyle: overflowCellStyle,
    flex: 2,
    minWidth: 120,
  },
  {
    field: 'preOrderDate',
    initialHide: true,
    tooltipField: 'preOrderDate',
    headerName: 'Pre-Order Date',
    headerNameTranslationKey: 'product.editProduct.preOrderDate',
    sortable: true,
    resizable: true,
    filter: 'agDateColumnFilter',
    valueFormatter: preorderDateFormat,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  /*{
    field: 'priceCode',
    tooltipField: 'priceCode',
    headerName: 'Price Code',
    headerNameTranslationKey: 'product.editProduct.priceCode',
    sortable: false,
    resizable: true,
    cellStyle: overflowCellStyle,
    flex: 1.5,
  },*/
  {
    field: 'catalogNumber',
    tooltipField: 'catalogNumber',
    headerName: 'Catalog #',
    headerNameTranslationKey: 'product.editProduct.catalog#',
    sortable: true,
    resizable: true,
    cellStyle: overflowCellStyle,
    flex: 2,
  },
  {
    field: 'albumState',
    tooltipField: 'albumState',
    headerName: 'Status',
    headerNameTranslationKey: 'product.editProduct.albumState',
    sortable: true,
    resizable: true,
    filter: ChecklistFilter,
    suppressHeaderMenuButton: false,
    cellRenderer: AlbumStateRenderer,
    cellClass: 'grid-badge',
    flex: 2,
    minWidth: 140,
  },
  {
    width: 36,
    headerName: ' ',
    field: 'action',
    cellRenderer: ProductListPopupCellRenderer,
    cellClass: 'action-menu-cell',
    suppressColumnsToolPanel: true,
    resizable: false,
    suppressMovable: true,
  },
];
